<template>
  <ul class="nav navbar-nav">
    <!-- Control Sidebar Toggle Button -->
    <li class="nav-item dropdown user user-menu">
      <a class="nav-link dropdown-toggle" href="javascript:void(0);" @click.stop="toggleSettings">
        <span class="username-name d-lg-inline-block d-none">{{ userObject.userName }}</span>
        <span class="username-icon"><i class="fas fa-cog"></i></span>
      </a>
      <ul class="dropdown-menu" v-if="showSettings" @click.stop>
        <!-- User image -->
        <li class="user-header">
          <p>
            {{ userObject.userEmail }}
          </p>
          <p>
            <small><a href="javascript:void(0);" class="change-password">Change Password</a></small>
          </p>
        </li>
        <!-- Menu Footer-->
        <li class="user-footer">
          <div class="float-left">
            <a href="javascript:void(0);" class="btn btn-light btn-flat"><i class="fas fa-user-circle" aria-hidden="true"></i></a>
          </div>
          <div class="float-right">
            <a href="javascript:void(0);" class="btn btn-light btn-flat"><i class="fas fa-power-off" aria-hidden="true"></i></a>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
// @ is an alias to /src
import { EventBus } from '@/event-bus.js'

export default {
  name: 'Settings',
  props: {
    userObject: Object
  },
  data() {
    return {
      showSettings: false
    }
  },
  computed: {
    
  },
  mounted() {
    EventBus.$on(['app-click','notifications-click','toggle-action'], () => {
      this.showSettings = false;
    });
  },
  methods: {
    toggleSettings: function() {
      EventBus.$emit('settings-click');
      this.showSettings = this.showSettings ? false : true;
    }
  }
}
</script>
